import { BaseCommandItem } from './base-command-item';
import type { CommandsCategoryInterface, CommandsPageInterface } from '@nts/std/interfaces';

export class CommandsCategory extends BaseCommandItem implements CommandsCategoryInterface {
    pages: Array<CommandsPageInterface> = new Array<CommandsPageInterface>();

    addPage(page: CommandsPageInterface) {
        if (this.pages.find(p => p.name === page.name) == null) {
            this.pages.push(page);
        }
    }

    removeEmptyPages() {
        this.pages.forEach(p => p.removeEmptyGroups());
        const pages = this.pages.filter(p => p.commandGroups.length > 0);
        this.pages = new Array<CommandsPageInterface>();
        this.pages.push(...pages);
    }
}
